module.exports = __webpack_public_path__ + "1d10a07fabc30da886ef33644d9e5633.svg";